import { gql, useMutation } from '@apollo/client'
import { showAlert } from '../../../../../../common/Alert/util'
import { useDispatch } from 'react-redux'
import useTranslation from '../../../../../../i18n/useTranslation'

const useCreateTestpressUser = (onSuccess = () => { }, onError = () => { }) => {
  const dispatch = useDispatch()
  const { translate } = useTranslation()

  const [submit, { loading }] = useMutation(
    gql`
      mutation CreateTestpressUser(
        $firstName: String!
        $lastName: String!
        $email: String!
        $birthDate: String
        $state: String
        $batches: [String!]
        $graduationUniversity: String
        $graduationYear: Float
      ) {
        createTestpressUser(
          firstName: $firstName
          lastName: $lastName
          email: $email
          birthDate: $birthDate
          state: $state
          batches: $batches
          graduationUniversity: $graduationUniversity
          graduationYear: $graduationYear
        )
      }
    `
  )

  const execute = ({
    firstName,
    lastName,
    email,
    birthDate,
    state,
    batches,
    graduationUniversity,
    graduationYear
  }) => {
    submit({
      variables: {
        firstName,
        lastName,
        email,
        birthDate,
        state,
        batches,
        graduationUniversity,
        graduationYear
      }
    }).then(
      (res) => {
        showAlert({ status: 'success', text: translate('misc.testpressUserCreated') || 'Usuario creado con éxito.' }, dispatch)
        if (onSuccess) onSuccess(res)
      },
      (err) => {
        const errorObj = err?.graphQLErrors?.[0]?.extensions?.exception?.response;

        let errorMessage = 'Error creating user in Testpress.';

        if (errorObj && typeof errorObj === 'object') {
          const firstKey = Object.keys(errorObj)[0];
          if (firstKey && Array.isArray(errorObj[firstKey])) {
            errorMessage = errorObj[firstKey][0];
          }
        }
        showAlert({ status: 'error', text: errorMessage }, dispatch);

        if (onError) onError(err);
      }
    )
  }

  return { submit: execute, loading }
}

export default useCreateTestpressUser
